import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </M>
  );
};

// Masked line-by-line reveal. `animate` when ready (on-load) or in view.
// Observer sits on the unclipped wrapper; lines inherit the variant.
export const MaskLines = ({ lines, className = "", lineClass = "", ready, delay = 0, stagger = 0.12 }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(ready === undefined
      ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
      : { animate: ready ? "show" : "hidden" })}
  >
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClass}`}
          variants={{ hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 1.1, ease: EASE, delay: delay + i * stagger } } }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`eyebrow flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-gradient-to-r from-[#d4af37] to-transparent" />
    {children}
  </p>
);
